import { render, staticRenderFns } from "./systemMessage.vue?vue&type=template&id=677542b6"
import script from "./systemMessage.vue?vue&type=script&lang=js"
export * from "./systemMessage.vue?vue&type=script&lang=js"
import style0 from "./systemMessage.vue?vue&type=style&index=0&id=677542b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports